<div fxFlex="100" fxFlex.gt-sm="60" fxFlexOffset.gt-sm="20" style="margin-top: 20px;">
  <button routerLink="/displays" mat-raised-button color="primary" class="mb-1">
    Alle Displays
  </button>
  <mat-card *ngIf="!loading" style="margin-top: 20px;">
    <mat-card-header>
      <mat-card-title>
        Display {{display.nummer}} bearbeiten
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div>
        <mat-form-field>
          <input matInput placeholder="Display-Nummer" [(ngModel)]="display.nummer" required>
        </mat-form-field>
      </div>
      <div class="row">
        <div class="col-6">
          <mat-form-field style="width: 100%;">
            <textarea matInput placeholder="Display-Beschreibung" maxlength="512" rows="3"
                      [(ngModel)]="display.description" required></textarea>
          </mat-form-field>
        </div>
        <div class="col-6">
          <mat-form-field style="width: 100%;">
            <textarea matInput placeholder="Display-Inhalt" maxlength="512" rows="3" [(ngModel)]="display.content"
                      required></textarea>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-3">
          <mat-form-field style="width: 100%;">
            <input matInput placeholder="Preis" type="number" [(ngModel)]="display.price" required>
          </mat-form-field>
        </div>
        <div class="col-3">
          <mat-checkbox [(ngModel)]="display.rabatt" color="primary" [checked]="display.rabatt">Displaybezug erhöht
            Rabatt?
          </mat-checkbox>
        </div>
        <div class="col-3" *ngIf="display.rabatt">
          <mat-form-field style="width: 100%;">
            <input matInput placeholder="Rabatt Höhe (%)" type="number" [(ngModel)]="display.rabatt_hoehe" required>
          </mat-form-field>
        </div>
        <div class="col-3" [class.offset-3]="!display.rabatt">
          <mat-checkbox [(ngModel)]="display.rabatt_staffelmenge" color="primary">
            Display Staffel-Mengenrabatt
          </mat-checkbox>
        </div>
      </div>
      <div class="row">
        <div class="col-3">
          <mat-form-field style="width: 100%">
            <input matInput placeholder="Höhe (mm)" type="number" [(ngModel)]="display.hoehe">
          </mat-form-field>
        </div>
        <div class="col-3">
          <mat-form-field style="width: 100%">
            <input matInput placeholder="Breite (mm)" type="number" [(ngModel)]="display.breite">
          </mat-form-field>
        </div>
        <div class="col-3">
          <mat-form-field style="width: 100%">
            <input matInput placeholder="Tiefe (mm)" type="number" [(ngModel)]="display.tiefe">
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <mat-form-field style="width: 100%;">
            <textarea matInput placeholder="Zusatzinhalte" rows="3" maxlength="512"
                      [(ngModel)]="display.zusatzinhalte"></textarea>
          </mat-form-field>
        </div>
        <div class="col-6">
          <small>Produkte:</small>
          <mat-list>
            <mat-list-item *ngIf="display.rabatte.length == 0">
              Es sind noch keine Produkte für diese Displaynummer verfügbar.
              Bitte laden Sie ein entsprechendes Angebot hoch.
            </mat-list-item>
            <mat-list-item *ngFor="let r of display.rabatte">
              <span style="cursor: help;" [matTooltip]="r.name">{{r.pzn}}</span>
              <div style="margin-left: auto;">
                <mat-form-field>
                  <input placeholder="Display-Produkt-Anzahl " type="number" matInput [(ngModel)]="r.displayProduktAnzahl">
                </mat-form-field>
              </div>
            </mat-list-item>
          </mat-list>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-6">
          <input type="file" [hidden]="true" accept=".jpeg, .jpg" #pictureChooser (change)="choosedImage($event)">
          <button mat-raised-button color="primary" (click)="pictureChooser.click()">
            Display-Bild auswählen
          </button>
        </div>
        <div class="col-6">
          <mat-icon color="danger" style="float: right; cursor: pointer;" *ngIf="display.bild"
                    (click)="display.bild = null">clear
          </mat-icon>
          <img style="max-width: 250px;" [src]="display.bild" class="img-thumbnail" *ngIf="display.bild">
        </div>
      </div>
      <div class="row mt-3" *ngIf="errors.length > 0">
        <div class="col-6">
          <div class="alert alert-danger">
            <ul>
              <li *ngFor="let e of errors">{{e}}</li>
            </ul>
          </div>
        </div>
      </div>
    </mat-card-content>
    <mat-card-content style="display: flex;">
      <button mat-raised-button color="warn" [disabled]="deleting" (click)="askDelete()">
        <span>Löschen <mat-spinner color="warn" diameter="20" style="padding: 5px; display: inline-block"
                                   *ngIf="deleting"></mat-spinner></span>
      </button>
      <button mat-raised-button color="primary" style="margin-left: auto;" [disabled]="saving" (click)="save()">
        <span>Speichern <mat-spinner color="info" diameter="20" style="padding: 5px; display: inline-block"
                                     *ngIf="saving"></mat-spinner></span>
      </button>
    </mat-card-content>
  </mat-card>
  <mat-spinner *ngIf="loading" diameter="40"></mat-spinner>
</div>
